import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';
import useApplicationData from 'src/hooks/useApplicationData';
import useAutoplay from 'src/hooks/useAutoplay';
import TextOverflow from 'src/themes/cosmos/components/Text/TextOverflow';
import useAutoplayOverlay from './hooks/useAutoplayOverlay';
import styles from './styles.module.scss';

export interface IAutoplayOverlayProps {
  onHide: () => void;
}

const AutoplayOverlay = ({ onHide }: IAutoplayOverlayProps) => {
  useAutoplayOverlay();
  const { t } = useTranslation('common');
  const { nextMediaTitle } = useApplicationData();
  const { goToNextVideo } = useAutoplay();

  return (
    <div data-testid='autoplay-overlay' className={classNames(styles.overlay)}>
      <div className={styles.description}>
        <span>{t('autoplay.next')}</span>
        <TextOverflow asComponent='span'>{nextMediaTitle || ''}</TextOverflow>
      </div>
      <div className={styles.buttons}>
        <button className={styles.cancel} onClick={onHide}>
          {t('autoplay.btn_cancel')}
        </button>
        <button className={styles.continue} onClick={goToNextVideo}>
          {t('autoplay.btn_continue')}
        </button>
      </div>
    </div>
  );
};

export default memo(AutoplayOverlay);
